/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { ButtonProps } from '../../types/global/ButtonProps';
import { useLocation } from 'react-router-dom';

const Button: React.FC<ButtonProps> = ({
  loading = false,
  disabled,
  theme = 'primary',
  icon = null,
  href,
  size = 'md',
  underline = true,
  children,
  tag,
  className,
  type = 'button',
  ...rest
}) => {
  const location = useLocation();

  const buttonTheme = (theme: string) => {
    switch (theme) {
      case 'primary':
        return 'bg-green text-white border-2 border-transparent rounded-[4px]';
      case 'plain':
        return ``;
      case 'outline':
        return `bg-[#049E260F] rounded-full`;
      case 'secondary':
        return 'bg-[#F8B4005E] text-[#768396] rounded-[19px]';
      default:
        return 'bg-primary text-white border-2 border-transparent rounded-[5px]';
    }
  };

  const buttonSize = (size: string) => {
    switch (size) {
      case 'sm':
        return 'px-3 py-2';
      case 'md':
        return 'px-6 py-3';
      case 'xs':
        return 'px-[11px] py-[2px]';
      default:
        return 'px-4 py-2';
    }
  };

  const iconSize = (icon: string) => {
    switch (icon) {
      case 'sm':
        return 20;
      case 'md':
        return 24;
      case 'lg':
        return 32;
      case 'xl':
        return 36;
      default:
        return 24;
    }
  };

  const iconColor = (theme: string) => {
    switch (theme) {
      case 'primary':
        return '#fff';
      case 'secondary':
        return '#F8B400';
      default:
        return '#fff';
    }
  };
  const LinkTheme = (theme: string) => {
    switch (theme) {
      case 'primary':
        return 'text-green';
      case 'secondary':
        return 'text-green bg-green text-white border-2 border-transparent rounded-[5px]';
      default:
        return 'text-green';
    }
  };

  if (tag === 'a') {
    return (
      <Link
        to={`${href || location.pathname}`}
        className={`hover:text-orange ${LinkTheme(theme)} ${
          underline ? 'underline' : null
        } ${className}`}
      >
        {children}
        {icon && (
          <img
            src={`${icon}`}
            alt='arrow'
            className='block ml-3'
            width={iconSize(size)}
            height={iconSize(size)}
          />
        )}
      </Link>
    );
  }
  if (tag === 'aa') {
    return (
      <div
        className={`hover:text-orange ${LinkTheme(theme)} ${
          underline ? 'underline' : null
        } ${className}`}
      >
        {children}
        {icon && (
          <img
            src={`${icon}`}
            alt='arrow'
            className='block ml-3'
            width={iconSize(size)}
            height={iconSize(size)}
          />
        )}
      </div>
    );
  }

  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={`flex items-center font-poppins justify-center transition-all hover:brightness-90 disabled:brightness-[60%] ease-in text-center gap-4 font-normal disabled:cursor-not-allowed ${buttonTheme(
        theme,
      )} ${buttonSize(size)} ${className}`}
      {...rest}
    >
      <ClipLoader color={iconColor(theme)} loading={loading} size={20} />

      {icon && <img src={`${icon}`} width={iconSize(size)} height={iconSize(size)} />}
      {children}
    </button>
  );
};

export default Button;
